import { ltjsModule } from '../ltjsEnvironment';
/**
 * The EventDetachHandle is an object used to detach an event listener.  It is
 * returned by EventDispatcher.attachEvent().
 *
 * @class EventDetachHandle
 * @name sas.ltjs.commons.events.EventDetachHandle
 * @public
 */
var EventDetachHandle = /** @class */ (function () {
    function EventDetachHandle(detachFunction) {
        //
        // Assign the custom detachFunction for this instance
        //
        this._detachFunction = detachFunction;
    }
    /**
     * Detach the event listener from the associated EventDispacher.
     * The EventDispatcher contract requires that attached event listeners
     * are detached, and a failure to do so will result in memory leaks.
     */
    EventDetachHandle.prototype.detach = function () {
        this._detachFunction();
    };
    EventDetachHandle.createHandle = function (type, bridge) {
        bridge.retain();
        var dispatchBridge = bridge;
        return new EventDetachHandle(function () {
            if (dispatchBridge) {
                // tslint:disable-next-line:no-unsafe-any
                ltjsModule.module._ltjs_commons_EventDispatcher_removeEventListener(type, dispatchBridge.getClosetAddress());
                //
                // Release the retained DispatchBridge
                //
                dispatchBridge.release();
                dispatchBridge = null;
            }
        });
    };
    EventDetachHandle.createPropertyChangeHandle = function (propertyName, bridge) {
        bridge.retain();
        var dispatchBridge = bridge;
        return new EventDetachHandle(function () {
            if (dispatchBridge) {
                //
                // Put the propertyName into the closet, call the JNI method to remove the listener,
                // then release the temporary closet string.
                //
                var propertyNameAddress = ltjsModule.convertStringToC(propertyName);
                // tslint:disable-next-line:no-unsafe-any
                ltjsModule.module._ltjs_commons_EventDispatcher_removePropertyChangeEventListener(propertyNameAddress, dispatchBridge.getClosetAddress());
                ltjsModule.releasePrimitive(propertyNameAddress);
                //
                // Release the retained DispatchBridge
                //
                dispatchBridge.release();
                dispatchBridge = null;
            }
        });
    };
    return EventDetachHandle;
}());
export default EventDetachHandle;
